var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import FTLTableRowStyles from "../styles/FTLTableRowStyles.styles";
export default React.forwardRef((_a, ref) => {
    var { noCellBorder, type = "default", height, isDisabled, isFocusable, className = "" } = _a, otherProps = __rest(_a, ["noCellBorder", "type", "height", "isDisabled", "isFocusable", "className"]);
    const { root } = FTLTableRowStyles({
        noCellBorder,
        type,
        height,
        isDisabled,
        isFocusable,
    });
    return React.createElement("tr", Object.assign({ ref: ref, className: className + " " + root }, otherProps));
});
//# sourceMappingURL=FTLTableRow.js.map